// extracted by mini-css-extract-plugin
export default {"content":"content_content__o7Hpu","openDrawer":"content_openDrawer__GQ20K","feedbackBtn":"content_feedbackBtn__xmtEq"};